// Ícones (emojis) sugeridos no formulário de categoria, agrupados por ramo de
// negócio para atender empresas de segmentos diferentes (multi-tenant).
// Cada item é [emoji, palavras-chave usadas na busca].
export const CATEGORY_ICON_GROUPS = [
  {
    label: "Lanches e refeições",
    icons: [
      ["🍔", "hambúrguer lanche burger"],
      ["🍕", "pizza calzone esfiha"],
      ["🌭", "cachorro-quente hot dog"],
      ["🥪", "sanduíche"],
      ["🌮", "taco mexicano"],
      ["🌯", "burrito wrap"],
      ["🥙", "kebab árabe"],
      ["🧆", "falafel"],
      ["🍟", "batata frita porção"],
      ["🍳", "ovo frito café da manhã"],
      ["🥘", "panela prato feito lasanha forno travessa escondidinho"],
      ["🍲", "sopa caldo"],
      ["🥗", "salada fit"],
      ["🍝", "massa macarrão espaguete lasanha talharim nhoque penne ravioli fettuccine"],
      ["🍜", "lámen miojo yakisoba massa sopa"],
      ["🍛", "curry"],
      ["🍚", "arroz"],
      ["🍱", "bentô marmita"],
      ["🍣", "sushi japonês"],
      ["🍤", "camarão frutos do mar"],
      ["🍙", "onigiri"],
      ["🥟", "pastel guioza salgado ravioli capeletti massa recheada"],
      ["🥡", "comida para viagem chinesa"],
      ["🥞", "panqueca"],
      ["🧇", "waffle"],
      ["🥓", "bacon"],
      ["🥩", "carne churrasco"],
      ["🍗", "frango coxa"],
      ["🍖", "costela carne"],
      ["🥚", "ovo páscoa"],
      ["🍢", "espetinho"],
      ["🥣", "tigela açaí cereal"],
      ["🥫", "lata enlatado conserva molho refrigerante lata"],
      ["🫕", "fondue gratinado"],
      ["🧂", "sal tempero"],
      ["🦐", "camarão"],
      ["🦀", "caranguejo"],
      ["🐟", "peixe"],
      ["🦞", "lagosta frutos do mar"],
      ["🦑", "lula calamari"],
      ["🐙", "polvo"],
      ["🦪", "ostra"],
      ["🍠", "batata-doce assada"],
      ["🍘", "biscoito de arroz"],
      ["🍥", "kamaboko japonês"],
      ["🫔", "pamonha tamale"],
      ["🌾", "trigo massa artesanal grãos"],
      ["🐄", "boi carne bovina"],
      ["🐖", "porco carne suína"],
      ["🐔", "galinha frango caipira"],
      ["🐑", "cordeiro carneiro"],
      ["🍴", "talheres restaurante"],
      ["🥄", "colher sobremesa"],
      ["🥢", "hashi oriental"],
      ["🍽️", "prato executivo almoço"],
    ],
  },
  {
    label: "Hortifruti",
    icons: [
      ["🍇", "uva"],
      ["🍈", "melão"],
      ["🍉", "melancia"],
      ["🍊", "laranja"],
      ["🍋", "limão limonada"],
      ["🍌", "banana"],
      ["🍍", "abacaxi"],
      ["🥭", "manga"],
      ["🍎", "maçã vermelha"],
      ["🍏", "maçã verde"],
      ["🍐", "pera"],
      ["🍑", "pêssego"],
      ["🍒", "cereja"],
      ["🍓", "morango batida"],
      ["🫐", "mirtilo"],
      ["🥝", "kiwi"],
      ["🍅", "tomate"],
      ["🫒", "azeitona"],
      ["🥥", "coco cocada água de coco"],
      ["🥑", "abacate"],
      ["🍆", "berinjela"],
      ["🥔", "batata"],
      ["🥕", "cenoura"],
      ["🌽", "milho"],
      ["🌶️", "pimenta"],
      ["🫑", "pimentão"],
      ["🥒", "pepino"],
      ["🥬", "alface folhas verduras"],
      ["🥦", "brócolis"],
      ["🧄", "alho"],
      ["🧅", "cebola"],
      ["🍄", "cogumelo"],
      ["🥜", "amendoim"],
      ["🌰", "castanha"],
    ],
  },
  {
    label: "Padaria, doces e laticínios",
    icons: [
      ["🍞", "pão forma"],
      ["🥐", "croissant"],
      ["🥖", "pão francês baguete"],
      ["🫓", "pão sírio tapioca"],
      ["🥨", "pretzel"],
      ["🥯", "bagel rosca"],
      ["🧀", "queijo"],
      ["🧈", "manteiga"],
      ["🥛", "leite"],
      ["🍰", "bolo fatia torta doce sobremesa"],
      ["🎂", "bolo aniversário"],
      ["🧁", "cupcake bolinho muffin"],
      ["🥧", "torta quiche empadão"],
      ["🍮", "pudim flan sobremesa"],
      ["🍩", "rosquinha donut"],
      ["🍪", "cookie biscoito bolacha"],
      ["🍫", "chocolate brownie barra achocolatado"],
      ["🍬", "bala bombom doces"],
      ["🍭", "pirulito"],
      ["🍯", "mel"],
      ["🍦", "sorvete casquinha"],
      ["🍧", "raspadinha"],
      ["🍨", "sorvete taça"],
      ["🍡", "doce espeto brigadeiro docinhos"],
      ["🥮", "bolo lua"],
      ["🍿", "pipoca"],
      ["🥠", "biscoito da sorte"],
      ["🟫", "brownie quadrado chocolate"],
      ["🤎", "chocolate marrom brownie"],
    ],
  },
  {
    label: "Bebidas",
    icons: [
      ["☕", "café"],
      ["🍵", "chá"],
      ["🫖", "bule chá"],
      ["🧉", "chimarrão tereré mate"],
      ["🍼", "mamadeira bebê"],
      ["🧃", "suco caixinha néctar"],
      ["🥤", "refrigerante copo soda milkshake"],
      ["🧋", "bubble tea"],
      ["🍶", "saquê"],
      ["🍺", "cerveja chopp"],
      ["🍻", "cervejas brinde"],
      ["🥂", "espumante brinde"],
      ["🍷", "vinho"],
      ["🥃", "whisky destilado dose"],
      ["🍸", "drink coquetel"],
      ["🍹", "drink tropical caipirinha batida suco natural"],
      ["🍾", "champanhe garrafa refrigerante 2 litros"],
      ["🧊", "gelo"],
      ["💧", "água mineral"],
    ],
  },
  {
    label: "Mercado, casa e construção",
    icons: [
      ["🛒", "carrinho mercado"],
      ["🧺", "cesta"],
      ["🛍️", "sacola compras"],
      ["🧴", "frasco loção"],
      ["🧼", "sabonete"],
      ["🧽", "esponja limpeza"],
      ["🧻", "papel higiênico"],
      ["🪣", "balde"],
      ["🧹", "vassoura limpeza"],
      ["🧯", "extintor"],
      ["🕯️", "vela"],
      ["🛋️", "sofá móveis"],
      ["🛏️", "cama"],
      ["🪑", "cadeira"],
      ["🚪", "porta"],
      ["🪴", "vaso planta"],
      ["🧸", "brinquedo urso"],
      ["🔑", "chave"],
      ["🧷", "alfinete"],
      ["🧵", "linha costura"],
      ["🧶", "lã tricô"],
      ["🪡", "agulha costura"],
      ["🔌", "tomada elétrica"],
      ["💡", "lâmpada"],
      ["🔋", "pilha bateria"],
      ["🔧", "chave inglesa ferramenta"],
      ["🔨", "martelo"],
      ["🪛", "chave de fenda"],
      ["🧰", "caixa de ferramentas"],
      ["🪚", "serrote"],
      ["🧱", "tijolo construção"],
      ["🪜", "escada"],
      ["🔪", "faca"],
    ],
  },
  {
    label: "Saúde e beleza",
    icons: [
      ["💊", "remédio farmácia"],
      ["💉", "vacina injeção"],
      ["🩹", "curativo"],
      ["🩺", "estetoscópio médico"],
      ["🌡️", "termômetro"],
      ["🧪", "laboratório"],
      ["🦷", "dente dentista"],
      ["👓", "óculos ótica"],
      ["💄", "batom maquiagem"],
      ["💅", "unha manicure"],
      ["💇", "corte cabelo salão"],
      ["💈", "barbearia"],
      ["🪒", "barbear lâmina"],
      ["🪥", "escova de dente"],
      ["🧖", "spa sauna"],
      ["💆", "massagem"],
      ["🌸", "flor perfume"],
      ["🪞", "espelho"],
    ],
  },
  {
    label: "Moda e acessórios",
    icons: [
      ["👕", "camiseta"],
      ["👔", "camisa social"],
      ["👗", "vestido"],
      ["👖", "calça jeans"],
      ["🧥", "casaco jaqueta"],
      ["👚", "blusa"],
      ["🩱", "maiô"],
      ["👙", "biquíni"],
      ["🩳", "bermuda short"],
      ["🧦", "meias"],
      ["🧤", "luvas"],
      ["🧣", "cachecol"],
      ["🧢", "boné"],
      ["👒", "chapéu"],
      ["👠", "salto sapato"],
      ["👟", "tênis"],
      ["👞", "sapato social"],
      ["🥾", "bota"],
      ["🩴", "chinelo"],
      ["👜", "bolsa"],
      ["👛", "carteira"],
      ["🎒", "mochila"],
      ["💍", "anel joia"],
      ["⌚", "relógio"],
      ["🕶️", "óculos de sol"],
      ["💼", "maleta"],
    ],
  },
  {
    label: "Pets e natureza",
    icons: [
      ["🐶", "cachorro pet"],
      ["🐱", "gato pet"],
      ["🐠", "peixe aquário"],
      ["🐦", "pássaro"],
      ["🐰", "coelho páscoa"],
      ["🐹", "hamster"],
      ["🐢", "tartaruga"],
      ["🦴", "osso ração"],
      ["🐾", "patinha pet"],
      ["🌱", "muda broto vegano vegetariano"],
      ["🌿", "erva natural"],
      ["🍀", "trevo sorte"],
      ["🌻", "girassol"],
      ["🌹", "rosa flores"],
      ["🌷", "tulipa"],
      ["💐", "buquê flores"],
      ["🌵", "cacto"],
      ["🌳", "árvore"],
      ["🍃", "folhas natural"],
    ],
  },
  {
    label: "Tecnologia, lazer e serviços",
    icons: [
      ["📱", "celular"],
      ["💻", "notebook"],
      ["🖥️", "computador"],
      ["⌨️", "teclado"],
      ["🖨️", "impressora"],
      ["🎧", "fone de ouvido"],
      ["📷", "câmera foto"],
      ["🎮", "videogame jogos"],
      ["📺", "televisão"],
      ["🔊", "som caixa"],
      ["📦", "caixa pacote"],
      ["🚚", "entrega caminhão"],
      ["🛵", "moto delivery"],
      ["🚲", "bicicleta"],
      ["🚗", "carro automotivo"],
      ["⛽", "combustível posto"],
      ["🏪", "loja conveniência"],
      ["🏠", "casa"],
      ["📚", "livros"],
      ["✏️", "lápis papelaria"],
      ["📎", "clipe escritório"],
      ["🖊️", "caneta"],
      ["📒", "caderno"],
      ["🎨", "arte pintura"],
      ["🎵", "música"],
      ["🎸", "violão guitarra"],
      ["⚽", "futebol esporte"],
      ["🏀", "basquete"],
      ["🎾", "tênis esporte"],
      ["🏋️", "academia musculação"],
      ["🧩", "quebra-cabeça"],
      ["🎲", "dado jogos"],
    ],
  },
  {
    label: "Ocasiões e destaques",
    icons: [
      ["🎉", "festa promoção"],
      ["🎊", "confete"],
      ["🎈", "balão"],
      ["🎀", "laço"],
      ["🎁", "presente"],
      ["✨", "brilho novidade"],
      ["⭐", "estrela destaque"],
      ["🌟", "estrela brilhante"],
      ["💎", "diamante premium"],
      ["🔥", "fogo quente mais vendido"],
      ["❄️", "gelado frio"],
      ["❤️", "coração favorito"],
      ["💝", "dia dos namorados"],
      ["💯", "cem perfeito"],
      ["🆕", "novo"],
      ["🏷️", "etiqueta oferta"],
      ["💰", "dinheiro economia"],
      ["🏆", "troféu campeão"],
      ["🥇", "medalha primeiro"],
      ["👑", "coroa"],
      ["🎄", "natal"],
      ["🎅", "papai noel natal"],
      ["🎃", "halloween abóbora"],
      ["🌙", "noite lua"],
      ["☀️", "sol dia verão"],
      ["⚡", "rápido raio"],
      ["⏰", "horário despertador"],
      ["✅", "ok confirmado"],
      ["🌎", "mundo internacional"],
      ["🚫", "sem proibido"],
    ],
  },
];
